import { render, staticRenderFns } from "./HeatExchangeModule.vue?vue&type=template&id=0bafd233&scoped=true&"
import script from "./HeatExchangeModule.vue?vue&type=script&lang=js&"
export * from "./HeatExchangeModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bafd233",
  null
  
)

export default component.exports